// extracted by mini-css-extract-plugin
export var bottomRow = "styles-module--bottomRow--207a2";
export var column = "styles-module--column--91b00";
export var columns = "styles-module--columns--dc853";
export var companyDescription = "styles-module--companyDescription--5d12c";
export var companyLabel = "styles-module--companyLabel--a4d4b";
export var companyLogo = "styles-module--companyLogo--67527";
export var companyName = "styles-module--companyName--0381f";
export var container = "styles-module--container--89592";
export var div = "styles-module--div--7af23";
export var heading = "styles-module--heading--424b9";
export var icon = "styles-module--icon--19ca9";
export var link = "styles-module--link--a64a9";
export var links = "styles-module--links--ea85f";
export var logo = "styles-module--logo--bbe39";
export var productIcon = "styles-module--productIcon--4e365";
export var socialIcon = "styles-module--socialIcon--50d81";
export var socialIcons = "styles-module--socialIcons--6540b";
export var wide = "styles-module--wide--dd34b";
export var wrapper = "styles-module--wrapper--cdb86";